module.exports = __webpack_public_path__ + "img/laptop.79319245.svg";